export default __webpack_public_path__ + "media/images/banners/months/bnr_6-7dbad6eba7966bd78758cf8aeb6cd22b.jpg";